import { RefObject, useLayoutEffect, useState } from 'react';

export const useDialogMaxHeight = (containerRef: RefObject<HTMLElement>, show?: boolean) => {
  const [maxHeight, setMaxHeight] = useState<number>();

  const MIN_MARGIN = 100;
  const MIN_CONTENT_HEIGHT = 50;

  useLayoutEffect(() => {
    const modalElement = containerRef.current;
    let timerId: number;

    const updateSize = () => {
      if (modalElement) {
        const modalContent = modalElement.closest('.modal-content');
        const modalBody = modalElement.closest('.modal-body');
        if (modalContent && modalBody) {
          const modalHeight = modalContent.clientHeight;
          const bodyHeight = modalBody.clientHeight;

          const windowHeight = window.outerHeight;
          const maxModalHeight = windowHeight - 2 * MIN_MARGIN;

          const heightOffset = modalHeight - bodyHeight;
          const newBodyHeight = maxModalHeight - heightOffset;

          setMaxHeight(Math.max(newBodyHeight, MIN_CONTENT_HEIGHT));
        }
      }
    };

    const resizeHandler = () => {
      window.clearTimeout(timerId);
      timerId = window.setTimeout(updateSize, 600);
    };

    if (modalElement && show) {
      updateSize();
      window.addEventListener('resize', resizeHandler);
    }

    return () => {
      window.clearTimeout(timerId);
      window.removeEventListener('resize', resizeHandler);
    };
  }, [show]);

  return maxHeight;
};
